import { render, staticRenderFns } from "./AppInlineAlert.vue?vue&type=template&id=bb5fa0d0&"
import script from "./AppInlineAlert.vue?vue&type=script&lang=js&"
export * from "./AppInlineAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports